import React from "react";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  actionText?: string;
  onClickFunc?: () => void;
}

const SectionHeader = ({
  title,
  subtitle = "",
  actionText = "",
  onClickFunc,
}: SectionHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-8">
      <div className="flex flex-col">
        <p className="text-3xl md:text-4xl font-semibold text-[#0E121B] pb-2 capitalize">
          {title}
        </p>
        <p className="text-base font-medium text-gray500 capitalize">
          {subtitle}
        </p>
      </div>
      {actionText && (
        <button
          onClick={onClickFunc}
          className="text-blue-600 hover:text-blue-800 font-medium border border-gray600/40 p-2 px-4 rounded-full text-gray500"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default SectionHeader;
